import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import Modal from "react-responsive-modal";
import EllipsisText from "react-ellipsis-text";
import { getImageUrl, getPlaceHolderImage } from "../../../services";
import {
  getValueFromLanguageObject,
  getCurrencySymbol,
  formatPrice,
} from "../../../store";
import Lightbox from "react-image-lightbox";

class QuickViewProductDetailsModal extends Component {
  constructor(props) {
    super(props);
    const product = props.product || {};
    console.log("props in quick view modal", product);
    this.state = {
      qty: 1,
      availablequantity: product.availablequantity || 0,
      stock:
        product.availablequantity > 0
          ? getValueFromLanguageObject("str_instock") || "InStock"
          : getValueFromLanguageObject("str_out_of_stock") || "Out of Stock !",
      quantity:
        product.minimumorderquantity && product.minimumorderquantity >= 1
          ? product.minimumorderquantity
          : 1,
      isFullScreenImage: false,
      fullScreenImagePath: "",
    };
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.product &&
      (!prevProps.product || this.props.product.id !== prevProps.product.id)
    ) {
      const product = this.props.product;
      this.setState({
        availablequantity: product.availablequantity || 0,
        stock:
          product.availablequantity > 0
            ? getValueFromLanguageObject("str_instock") || "InStock"
            : getValueFromLanguageObject("str_out_of_stock") || "Out of Stock !",
        quantity:
          product.minimumorderquantity && product.minimumorderquantity >= 1
            ? product.minimumorderquantity
            : 1,
      });
    }
  }

  minusQty = () => {
    if (this.state.quantity > this.props.product.minimumorderquantity) {
      this.setState({
        stock: getValueFromLanguageObject("str_instock") || "InStock",
      });
      this.setState({ quantity: this.state.quantity - 1 });
    }
  };

  plusQty = () => {
    if (this.props.product.availablequantity > this.state.quantity) {
      this.setState({ quantity: this.state.quantity + 1 });
    } else {
      this.setState({
        stock:
          getValueFromLanguageObject("str_out_of_stock") || "Out of Stock !",
      });
    }
  };

  changeQty = (e) => {
    const { isInquiry, product } = this.props;
    const value = e.target.value;

    if (!isInquiry && product.availablequantity === 0) {
      return;
    }

    if (value === "" || value === "-") {
      this.setState({ quantity: "" });
      return;
    }

    const qty = parseInt(value, 10);
    if (isNaN(qty) || qty < 1) {
      return;
    }

    // Prevent entering more than availablequantity
    if (qty > product.availablequantity) {
      this.setState({
        quantity: product.availablequantity,
        stock: getValueFromLanguageObject("str_out_of_stock") || "Out of Stock !",
      });
      return;
    }

    this.setState({
      quantity: qty,
      stock: getValueFromLanguageObject("str_instock") || "InStock",
    });
  };

  handleOnClickOfProductImage = () => {
    const { product, masterDetailsObj } = this.props || {};
    const { productmedia } = product || [];
    const [productmediaFirst] = Array.isArray(productmedia) ? productmedia : [];
    let path = "";
    if (productmediaFirst) {
      const { productname } = productmediaFirst || {};
      path = getImageUrl(productname, masterDetailsObj);
    } else {
      path = getPlaceHolderImage();
    }

    this.setState({
      isFullScreenImage: true,
      fullScreenImagePath: path,
    });
  };

  render() {
    const {
      product,
      masterDetailsObj,
      symbol,
      isInquiry,
      onAddToCartClicked,
      isQuickViewProductDetailsModalShow,
      handleCloseQuickViewProductDetailsModal,
      category,
    } = this.props;

    if (!product) {
      return null; // Don't render if product is not set
    }

    const {
      name,
      price,
      productmedia,
      totalCartCounter,
      id,
      category: productCategory,
    } = product || {};
    const { name: categoryName } = category || {};
    const { name: subCategoryName } = productCategory || {};
    const [firstCategory] = Array.isArray(productCategory) ? productCategory : [];
    const { category: ctr } = firstCategory || {};
    const { name: ctrName } = ctr || {};

    const { isFullScreenImage, fullScreenImagePath } = this.state || {};

    const strThereAre =
      getValueFromLanguageObject("str_there_are") || "There are";

    const strUnitsOfItemAlreadyInTheCart =
      getValueFromLanguageObject("str_units_of_item_already_in_the_cart") ||
      "units of item already in the cart";

    const strMinimumOrderQuantity =
      getValueFromLanguageObject("str_minimum_order_quantity") ||
      "Minimum Order Quantity";

    return (
      <>
        <Modal
          open={isQuickViewProductDetailsModalShow}
          center
          onClose={handleCloseQuickViewProductDetailsModal}
        >
          <div
            className="modal-dialog modal-lg modal-dialog-centered"
            role="document"
          >
            <div className="modal-content quick-view-modal">
              <div className="modal-body">
                <div className="row">
                  <div className="col-lg-6  col-xs-12">
                    <div
                      className="quick-view-img"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginTop: "30px",
                      }}
                    >
                      <div
                        className="quick-image-box"
                        onClick={() => this.handleOnClickOfProductImage()}
                      >
                        <img
                          src={
                            productmedia.length > 0
                              ? getImageUrl(
                                  productmedia[0].productname,
                                  masterDetailsObj
                                )
                              : getPlaceHolderImage()
                          }
                          alt=""
                          className="img-fluid"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = getPlaceHolderImage();
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 rtl-text">
                    <div className="product-right">
                      <div className="border-product">
                        <h2 className="product-title">
                          <EllipsisText text={name} length={35} />
                        </h2>
                        {isInquiry ? (
                          <div />
                        ) : (
                          <h3 style={{ whiteSpace: 'nowrap' }}>
                            {formatPrice(price)}
                          </h3>
                        )}
                        {categoryName && (
                          <div className="border-product">
                            <h6 className="product-title">
                              {getValueFromLanguageObject("str_category") ||
                                "category"}
                            </h6>
                            <p>{categoryName || "-"}</p>
                          </div>
                        )}
                        {(subCategoryName || ctrName) && (
                          <div className="border-product">
                            <h6 className="product-title">
                              {getValueFromLanguageObject("str_sub_category") ||
                                "sub-category"}
                            </h6>
                            <p>{subCategoryName || ctrName || "-"}</p>
                          </div>
                        )}
                        <div className="product-description border-product">
                          {!isInquiry && (
                            <div className="instock-cls">
                              {this.state.stock}
                            </div>
                          )}
                          <h6 className="product-title">
                            {getValueFromLanguageObject("str_quantity") ||
                              "quantity"}
                          </h6>

                          <div className="qty-box">
                            <div className="input-group">
                              <span className="input-group-prepend">
                                <button
                                  type="button"
                                  className="btn quantity-left-minus"
                                  onClick={this.minusQty}
                                  data-type="minus"
                                  data-field=""
                                >
                                  <i className="fa fa-angle-left" />
                                </button>
                              </span>
                              <input
                                type="number"
                                name="quantity"
                                value={this.state.quantity}
                                onChange={this.changeQty}
                                className="form-control input-number"
                                min="1"
                                max={product.availablequantity}
                                minLength="1"
                                maxLength="100000"
                              />
                              <span className="input-group-prepend">
                                <button
                                  type="button"
                                  className="btn quantity-right-plus"
                                  onClick={this.plusQty}
                                  data-type="plus"
                                  data-field=""
                                >
                                  <i className="fa fa-angle-right" />
                                </button>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="product-description mb-3 text-danger">
                          {this.props.product &&
                            this.props.product.minimumorderquantity &&
                            this.props.product.minimumorderquantity > 1 && (
                              <>
                                {`${strMinimumOrderQuantity}: ${
                                  this.props.product.minimumorderquantity
                                }`}
                              </>
                            )}
                        </div>
                        <div className="product-description mb-3">
                          {totalCartCounter > 0 && (
                            <>
                              {`${strThereAre} ${totalCartCounter} ${strUnitsOfItemAlreadyInTheCart}`}
                            </>
                          )}
                        </div>
                        <div className="product-buttons">
                          <button
                            className="btn btn-solid"
                            onClick={async () => {
                              onAddToCartClicked(
                                product,
                                this.state.quantity,
                                isInquiry
                              );
                            }}
                            disabled={
                              !isInquiry && product.availablequantity === 0
                                ? true
                                : false
                            }
                          >
                            {isInquiry
                              ? getValueFromLanguageObject(
                                  "str_add_to_inquiry"
                                ) || "Add To Inquiry"
                              : getValueFromLanguageObject("str_add_to_cart") ||
                                "Add to cart"}
                          </button>
                          <Link
                            to={`/singleproduct/${id}`}
                            className="btn btn-solid"
                          >
                            {getValueFromLanguageObject("str_view_detail") ||
                              "view detail"}
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>

        {isFullScreenImage && (
          <Lightbox
            mainSrc={fullScreenImagePath}
            onCloseRequest={() =>
              this.setState({
                isFullScreenImage: false,
                fullScreenImagePath: "",
              })
            }
          />
        )}
      </>
    );
  }
}

export default withRouter(QuickViewProductDetailsModal);
